import React from 'react';
import ContentLoader from 'react-content-loader';

const SignatureDrawerSkeleton = () => {
  return (
    <>
      <ContentLoader speed={2} width={1000} height={200} viewBox="0 0 1000 200">
        <rect x="20" y="15" rx="0" ry="0" width="100" height="20" />
        <rect x="20" y="60" rx="0" ry="0" width="500" height="20" />
        <rect x="20" y="90" rx="0" ry="0" width="700" height="15" />
        <rect x="20" y="120" rx="0" ry="0" width="550" height="10" />
      </ContentLoader>
      <ContentLoader speed={2} width={1000} height={600} viewBox="0 0 1000 600">
        <rect x="20" y="15" rx="0" ry="0" width="100" height="45" />
        <rect x="320" y="15" rx="0" ry="0" width="100" height="45" />
        <rect x="640" y="15" rx="0" ry="0" width="100" height="45" />
        <rect x="926" y="15" rx="0" ry="0" width="100" height="45" />
      </ContentLoader>
      <ContentLoader
        style={{ marginLeft: -35, marginTop: '-35rem' }}
        speed={2}
        viewBox="0 0 1000 550"
      >
        <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
        <rect x="875" y="110" rx="0" ry="0" width="40" height="40" />
        <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
        <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
        <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
        <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
        {/* sq */}
        <rect x="878" y="172" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
        <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
        <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
        <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
        {/* sq */}
        <rect x="880" y="230" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
        <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
        <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
        <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
        {/* sq */}
        <rect x="882" y="290" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
        <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
        <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
        <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
        {/* sq */}
        <rect x="880" y="350" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
        <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
        <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
        <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
        {/* sq */}
        <rect x="882" y="410" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
        <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
        <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
        <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
        <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
        <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
        {/* sq */}
        <rect x="882" y="470" rx="0" ry="0" width="40" height="40" />
        {/* sq */}
        <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
        <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
        <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
        <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
        <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
        <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
        <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
        <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
        <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
        <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
      </ContentLoader>
    </>
  );
};

export default SignatureDrawerSkeleton;
